import {
    mapState
} from "vuex";

export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapState({
            stageList: state => state.filter.stageList,
            subjectList: state => state.filter.subjectList,
            publisherList: state => state.filter.publisherList,
            termList: state => state.filter.termList,
            difficultyList: state => state.filter.difficultyList,
        }),
    },
    methods:{
        // 根据值返回对象
        getDictObject(type,value){
            let list = [];
            let typeId = '';
            let typeName = '';
            if(type == 'stage'){
                list = this.stageList;
                typeId = 'stageId';
                typeName = 'stageName';
            }else if(type == 'subject'){
                list = this.subjectList;
                typeId = 'subjectId';
                typeName = 'subjectName';
            }else if(type == 'publish'){
                list = this.publisherList;
                typeId = 'publisherId';
                typeName = 'publisherName';
            }else if(type == 'term'){
                list = this.termList;
                typeId = 'termId';
                typeName = 'termName';
            }else if(type == 'difficulty'){
                list = this.difficultyList;
                typeId = 'difficultyId';
                typeName = 'difficultyName';
            }
            return list.filter(item=>item[typeId] == value)[0]?.[typeName]
        }
    }
}